import React from "react";
import { CartContext } from "../hooks/use-cart";
import { useProvideCart } from "../hooks/use-provide-cart";

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = useProvideCart();
  return React.createElement(CartContext.Provider, { value }, children);
};
